import { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Outlet } from '@usas/ui-web/wrappers/ReactRouterDom';

import Member from './views/member/Member';
import MemberAdministration from './views/memberAdministration/MemberAdministration';
import HqOfferingManagement from './views/offeringManagement/offeringManagementHq/HqOfferingMangement';
import LscOfferingManagement from './views/offeringManagement/offeringManagementLsc/LscOfferingMangement';
import QuickAdd from './views/quickAddAthlete/QuickAdd';
import OfficialsTrackingSystem from './views/officialsTrackingSystem/OfficialsTrackingSystem';
import MiniMemberMerge from './views/miniMemberMerge/MiniMemberMerge';
// import MemberSummaryDashboard from './views/memberSummaryDashboard/';
import LSCReporting from './views/lscReporting/LSCReporting';
import HQReporting from './views/hqReporting/HqReporting';
// import ClubTimes from './views/clubTimes/ClubTimes'
import ClubTimesWithParams from './views/clubTimesKendoReportSample/ClubTimesWithParams';
import TimesDetailKendoReport from './views/timesDetailKendoReport/TimesDetailKendoReport';
import RelayTimesDetailKendoReport from './views/relayTimesDetailKendoReport/RelayTimesDetailKendoReport';
import CompetitionDetailKendoReport from './views/competitionDetailKendoReport/CompetitionDetailKendoReport';
import MeetDetailKendoReport from './views/meetDetailKendoReport/MeetDetailKendoReport';
import MemberDetailKendoReport from './views/memberDetailKendoReport/MemberDetailKendoReport';
import DynamicClubReport from './views/dynamicClubReporting/DynamicClubReporting';
import MemberCardLookup from './views/member/memberCardLookup/MemberCardLookup';
import EducationReporting from './views/educationReporting/EducationReporting';
import NTRegistration from './views/nationalTeamRegistration/NTRegistration';
import CommitteeReporting from './views/committeeReporting/CommitteeReporting';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import PageNotFound from '@usas/ui-web/components/PageNotFound';
import UnexpectedError from '@usas/ui-web/components/UnexpectedError';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';
import ErrorBoundary from '@usas/ui-web/components/errors/ErrorBoundary';
import ErrorBoundaryFallback from '@usas/ui-web/components/errors/ErrorBoundaryFallback';
// import KendoPdfTest from './views/clubTimesKendoReportSample/KendoPdfTest';
import ImxDetailReport from './views/kendoReports/imxDetailReport/ImxDetailReport';
import VccDetailReport from './views/kendoReports/vccDetailReport/VccDetailReport';
import RetentionDetailReport from './views/kendoReports/retentionDetailReport/RetentionDetailReport';
import ClubExcellenceDetailReport from './views/kendoReports/clubExcellenceDetailReport/ClubExcellenceDetailReport';  
import MembershipDetailReport from './views/kendoReports/membershipDetailReport/MembershipDetailReport';
import ClubMembershipDetailReport from './views/kendoReports/clubMembershipDetailReport/ClubMembershipDetailReport';

const AppRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <Routes>
        <Route path={navRoutes['HOME']?.path} element={<Fragment><Outlet /></Fragment>}>
          <Route path={navRoutes['MEMBER_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['MEMBER_ROOT']}
                editElement={<Member />} />
            }
          />
          <Route path={navRoutes['MEMBER_ADMIN_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['MEMBER_ADMIN_ROOT']}
                editElement={<MemberAdministration />} />
            }
          />
          <Route path={navRoutes['OFFERING_MANAGMENT_ROOT_HQ']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['OFFERING_MANAGMENT_ROOT_HQ']}
                editElement={<HqOfferingManagement />} />
            }
          />
          <Route path={navRoutes['OFFERING_MANAGMENT_ROOT_LSC']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['OFFERING_MANAGMENT_ROOT_LSC']}
                editElement={<LscOfferingManagement />} />
            }
          />
          <Route path={navRoutes['QUICK_ADD_ATHLETE_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['QUICK_ADD_ATHLETE_ROOT']}
                editElement={<QuickAdd />} />
            }
          />
          <Route path={navRoutes['OTS_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['OTS_ROOT']}
                editElement={<OfficialsTrackingSystem />} />
            }
          />
          <Route path={navRoutes['MEMBER_MERGE']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['MEMBER_MERGE']}
                editElement={<MiniMemberMerge />} />
            }
          />
          {/* <Route path={navRoutes['MEMBERSHIP_SUMMARY_DASHBOARD']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['MEMBERSHIP_SUMMARY_DASHBOARD']}
                editElement={<MemberSummaryDashboard />} />
            }
          /> */}
          <Route path={navRoutes['MEMBER_CARD_SEARCH']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['MEMBER_CARD_SEARCH']}
                editElement={<MemberCardLookup />} />
            }
          />
          <Route path={navRoutes['LSC_REPORTING_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['LSC_REPORTING_ROOT']}
                editElement={<LSCReporting />} />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_HQ_REPORTING']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_HQ_REPORTING']}
                editElement={<HQReporting />} />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_HQ_CLUB_TIMES']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_HQ_CLUB_TIMES']}
                // editElement={<ClubTimes />} 
                // editElement={<ClubTimesNew />} 
                editElement={<ClubTimesWithParams />}
              />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_TIMES_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_TIMES_DETAIL']}
                editElement={<TimesDetailKendoReport />}
              />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_RELAY_TIMES_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_RELAY_TIMES_DETAIL']}
                editElement={<RelayTimesDetailKendoReport />}
              />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_COMPETITION_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_COMPETITION_DETAIL']}
                editElement={<CompetitionDetailKendoReport />}
              />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_MEET_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_MEET_DETAIL']}
                editElement={<MeetDetailKendoReport />}
              />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_MEMBERSHIP_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_MEMBERSHIP_DETAIL']}
                editElement={<MembershipDetailReport />}
              />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_CLUB_MEMBERSHIP_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_CLUB_MEMBERSHIP_DETAIL']}
                editElement={<ClubMembershipDetailReport />}
              />
            }
          />
          <Route path={navRoutes['USA_SWIMMING_HQ_BIGQUERY_SCRIPT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_HQ_BIGQUERY_SCRIPT']}
                editElement={<DynamicClubReport />} />
            }
          />
          <Route path={navRoutes['EDUCATION_REPORTING']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['EDUCATION_REPORTING']}
                editElement={<EducationReporting />} />
            }
          />
          <Route path={navRoutes['NT_REGISTRATION_ROOT']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['NT_REGISTRATION_ROOT']}
                editElement={<NTRegistration />} />
            } />
          <Route path={navRoutes['COMMITTEE_REPORTING']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['COMMITTEE_REPORTING']}
                editElement={<CommitteeReporting />} />
            } />

          {/* <Route path={navRoutes['USA_SWIMMING_PDF_TEST']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_PDF_TEST']}
                editElement={<KendoPdfTest />} />
            } /> */}

          <Route path={navRoutes['USA_SWIMMING_IMX_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_IMX_DETAIL']}
                editElement={<ImxDetailReport />} />
            } />
            
          <Route path={navRoutes['USA_SWIMMING_VCC_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_VCC_DETAIL']}
                editElement={<VccDetailReport />} />
            } />

          <Route path={navRoutes['USA_SWIMMING_RETENTION_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_RETENTION_DETAIL']}
                editElement={<RetentionDetailReport />} />
            } />

          <Route path={navRoutes['USA_SWIMMING_CLUB_EXCELLENCE_DETAIL']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['USA_SWIMMING_CLUB_EXCELLENCE_DETAIL']}
                editElement={<ClubExcellenceDetailReport />} />
            } />

          <Route path="500" element={<UnexpectedError />} />
          <Route path="/*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
};

export default AppRoutes;